// extracted by mini-css-extract-plugin
export default {"footer":"Footer_footer__kXlYa","socials":"Footer_socials__7h4n1","icon":"Footer_icon__Zscac","name":"Footer_name__f3GY6"};